module.exports = __webpack_public_path__ + "static/media/ANY-FTM.3a53ac31.png";